import Phaser from 'phaser';

export default class ShapeBackground extends Phaser.GameObjects.Rectangle {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, w,h, color = 0xff0000) {
    super(scene, 0,0,w,h, color);

    this.curWidth = w;
    this.curHeight = h;
    this.curColor = color;

    this.setOrigin(0);
  }
}